import { defineRule,configure } from 'vee-validate';

import {
  required as rule_required,
  email as rule_email,
  min as rule_min,
  confirmed as rule_confirmed,
  regex as rule_regex,
  between as rule_between,
  alpha as rule_alpha,
  integer as rule_integer,
  digits as rule_digits,
  alpha_dash as rule_alpha_dash,
  alpha_num as rule_alpha_num,
  length as rule_length,
  max as rule_max,
  image as rule_image
} from '@vee-validate/rules'
// import ar from '@vee-validate/i18n/dist/locale/ar.json'
// import en from '@vee-validate/i18n/dist/locale/en.json'

// // eslint-disable-next-line object-curly-newline
import { validatorPassword } from './validators'
import { Value } from 'sass';

// // ////////////////////////////////////////////////////////
// // General
// // ////////////////////////////////////////////////////////

// export const required = (value,ctx) => {
//   if(!rule_required(value)){
//     return `El ${ctx.field} es requerido`;
//   }
//   return true;
// }

export const required = (value,ctx = {}, message = null) => {
  // Refuerza la obtención del nombre del campo
  // Si ctx no existe o ctx.field no existe, usa 'este campo' como fallback
  const fieldName = ctx?.field?.name || "este campo";

  if (!rule_required(value)) {
    // Si la validación falla (rule_required retorna false)
    return message || `El campo ${fieldName} es requerido`;
  }

  return true;
};

export const email = (value,ctx) => {
  if (!rule_email(value)) {
    return `El ${ctx.field} debe ser un correo electrónico válido`;
  }
  return true;
}
export const password = (value,ctx) => {
   if (!validatorPassword(value)) {
     return `Este campo ${ctx.field}  debe contener al menos una mayúscula, una minúscula, un carácter especial y un dígito`;
   }
   return true;
}

export const min = (value,limit,ctx,mensaje = null) => {

  if (value.length < limit) {
    return mensaje || `El campo ${ctx.field} no debe ser menor a ${limit} caracteres.`;
  }

  return true;
};

export const requiredUnless = (value,[otherFieldValue],ctx) => {
  if (!otherFieldValue && !rule_required(value)) {
    return `El ${ctx.field} es requerido.`;
  }
  return true;
}

export const requiredIf = (value, [otherFieldValue, expectedValue], ctx) => {
  if (otherFieldValue === expectedValue && !rule_required(value)) {
    return `El ${ctx.field} es requerido.`;
  }
  return true;
};

defineRule('requiredIf', (value, args, ctx) => requiredIf(value, args, ctx));

defineRule('required', (value,ctx) => required(value,ctx));
defineRule('email',(value,ctx) => email(value,ctx))
defineRule('password', (value,ctx) => password(value,ctx));  
defineRule('min', (value, args,ctx) => min(value, args,ctx));


defineRule('requiredUnless', requiredUnless);

// export const min = extend('min', { ...rule_min, 
//   message:'Sú {_field_} no debe ser menor a {length} carácteres'
//   }
// )

// export const max = extend('max', {
//   ...rule_max,
//   message:'Sú {_field_} no debe ser mayor a {length} caracteres.'
// })

// export const comision = extend('comision',{
//   validate: (value, args) => (Number(value) >= args.minimo && Number(value) <= args.maximo ),
//   params:['minimo','maximo'],
//   message: 'Sú {_field_} debe estar entre {minimo} y {maximo} %'

// })

// export const required_array = extend('required_array',{
//   validate:required_array_content,
//   message:'Este campo es requerido'
// });

// export const confirmed = rule_confirmed;
export const confirmed = (val,val_anterior,ctx) => {
  if(val !== val_anterior){
    return "El campo no es igual al campo anterior"
  }
  return true;
}

// export const regex = extend('regex', rule_regex)

// export const between = extend('between', rule_between)

// export const alpha = extend('alpha', rule_alpha)

// export const integer = extend('integer', rule_integer)

// export const digits = extend('digits', rule_digits)

// export const alphaDash = extend('alpha-dash', rule_alpha_dash)

// export const alphaNum = extend('alpha-num', rule_alpha_num)

// export const length = extend('length', rule_length)

// export const positive = extend('positive', {
//   validate: validatorPositive,
//   message: 'Please enter positive number!',
// })

// export const credit = extend('credit-card', {
//   validate: validatorCreditCard,
//   message: 'It is not valid credit card!',
// })


// export const url = extend('url', {
//   validate: validatorUrlValidator,
//   message: 'URL is invalid',
// })


// export const mountMax = extend('mountMax',{
//   validate:montoMax,
//   params:['monto'],
//   message:'El monto debe ser menor'
// });

export const mountMax = (value, monto,ctx) => {
  if (Number(value) > Number(monto)) {
    return `El ${ctx.field} debe ser menor o igual a ${monto}`;
  }
  return true;
}

defineRule('mountMax', (value, [monto], ctx) => mountMax(value, monto, ctx));

export const image = (value,ctx) => {
  if(!rule_image(value)){
    return `El ${ctx.field} no es valido, debe ser del tipo imagen, con extensiones: png,jpg,jpeg,...`;
  }
};

defineRule('image',(value,ctx) => image(value,ctx))

export const minLength = (value, length, ctx) => {
  if (value.length < length) {
    return `El campo ${ctx.field} debe tener al menos ${length} caracteres.`;
  }
  return true;
};

defineRule('minLength', (value, [length], ctx) => minLength(value, length, ctx));

export const maxLength = (value, length, ctx) => {
  if (value.length > length) {
    return `El campo ${ctx.field} no debe exceder ${length} caracteres.`;
  }
  return true;
};

defineRule('maxLength', (value, [length], ctx) => maxLength(value, length, ctx));

export const alphaNum = (value, ctx) => {
  const regex = /^[a-zA-Z0-9]*$/;
  if (!regex.test(value)) {
    return `El campo ${ctx.field} solo puede contener caracteres alfanuméricos.`;
  }
  return true;
};

defineRule('alphaNum', (value, ctx) => alphaNum(value, ctx));

// // Install English and Arabic localizations.
// localize({
//   en: {
//     messages: en.messages,
//     names: {
//       email: 'Email',
//       password: 'Password',
//     },
//     fields: {
//       password: {
//         min: '{_field_} is too short, you want to get hacked?',
//       },
//     },
//   },
//   ar: {
//     messages: ar.messages,
//     names: {
//       email: 'البريد الإلكتروني',
//       password: 'كلمة السر',
//     },
//     fields: {
//       password: {
//         min: 'كلمة السر قصيرة جداً سيتم اختراقك',
//       },
//     },
//   },
// })
// ////////////////////////////////////////////////////////
// NOTE:
// Quasar validation for reference only
// Remove this note once development is finished and make sure to
// to convert all of them in veevalidate version
// ////////////////////////////////////////////////////////

// export const required = (val) => {
//   return (val && val.length > 0) || '*Field is required'
// }

// export const required_obj = (obj) => {
//   if (obj === null || obj === undefined) return '*Field is required'
//   return (Object.entries(obj).length > 0 && obj.constructor === Object) || '*Field is required'
// }

// export const no_blank_spaces_arr = (arr) => {
//   return arr.every(val => (val.trim() && val.trim().length > 0)) || 'Blank Spaces are not allowed'
// }

// export const url = val => {
//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // Used
//   // https://stackoverflow.com/questions/4314741/url-regex-validation

//   // Other
//   // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
//   // https://www.w3resource.com/javascript-exercises/javascript-regexp-exercise-9.php
//   // https://www.geeksforgeeks.org/how-to-validate-url-using-regular-expression-in-javascript/

//   /* eslint-disable no-useless-escape */
//   const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
//   /* eslint-enable no-useless-escape */
//   return re.test(val) || 'URL is invalid'
// }

// export const date = val => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // https://github.com/quasarframework/quasar/blob/dev/ui/src/utils/patterns.js
//   return /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(val) || 'Date is invalid'
// }

// export const max = (val, max) => {

//   // If blank return
//   if (val === undefined || val === null) return true

//   return val.length <= max || `More than ${max} characters are not allowed`
// }

// export const max_arr = (val, max) => {
//   return val.length <= max || `More than ${max} values are not allowed`
// }

// export const min = (val, min) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   return val.length >= min || `Minimum ${min} characters are required`
// }

// export const num_range = (val, min, max) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   const msg = 'Value is invalid'
//   if (min === null) return val <= max || msg
//   else if (max === null) return val >= min || msg
//   else return (val >= min && val <= max) || msg
// }
